import { put, takeLatest } from "redux-saga/effects";
import {
    FETCH_VIDEO_EARNINGS_REQUEST,
    FETCH_VIDEO_EARNINGS_SUCCESS,
    FETCH_VIDEO_EARNINGS_FAILURE,
    FETCH_TIP_EARNINGS_REQUEST,
    FETCH_TIP_EARNINGS_SUCCESS,
    FETCH_TIP_EARNINGS_FAILURE,
    FETCH_SUBS_EARNINGS_REQUEST,
    FETCH_SUBS_EARNINGS_SUCCESS,
    FETCH_SUBS_EARNINGS_FAILURE,
    FETCH_PAID_EARNINGS_REQUEST,
    FETCH_PAID_EARNINGS_SUCCESS,
    FETCH_PAID_EARNINGS_FAILURE,
    FETCH_LIVESTREAM_EARNINGS_SUCCESS,
    FETCH_LIVESTREAM_EARNINGS_FAILURE,
    FETCH_LIVESTREAM_EARNINGS_REQUEST
} from "../actions/ActionConstant";
import api from "../../Environment";

// VIDEO
function* fetchVideoSaga(action) {
    try {
        const inputData = action.payload;

        const response = yield api.postMethod("video_post_earnings", inputData);
        if (response.data.success) {
            yield put({
                type: FETCH_VIDEO_EARNINGS_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({ type: FETCH_VIDEO_EARNINGS_FAILURE });
        }
    } catch (error) {
        yield put({ type: FETCH_VIDEO_EARNINGS_FAILURE });
    }
}

// TIPS
function* fetchTipSaga(action) {
    try {
        const inputData = action.payload;

        const response = yield api.postMethod("tip_earnings", inputData);

        if (response.data.success) {
            yield put({
                type: FETCH_TIP_EARNINGS_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({ type: FETCH_TIP_EARNINGS_FAILURE });
        }
    } catch (error) {
        yield put({ type: FETCH_TIP_EARNINGS_FAILURE });
    }
}

// SUBS
function* fetchSubsSaga(action) {
    try {
        const inputData = action.payload;

        const response = yield api.postMethod("subscription_earnings", inputData);

        if (response.data.success) {
            yield put({
                type: FETCH_SUBS_EARNINGS_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({ type: FETCH_SUBS_EARNINGS_FAILURE });
        }
    } catch (error) {
        yield put({ type: FETCH_SUBS_EARNINGS_FAILURE });
    }
}

// PAID POST
function* fetchPaidPostSaga(action) {
    try {
        const inputData = action.payload;

        const response = yield api.postMethod("paid_post_earnings", inputData);
        if (response.data.success) {
            yield put({
                type: FETCH_PAID_EARNINGS_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({ type: FETCH_PAID_EARNINGS_FAILURE });
        }
    } catch (error) {
        yield put({ type: FETCH_PAID_EARNINGS_FAILURE });
    }
}

// LIVESTREAM
function* fetchLiveStreamSaga(action) {
    try {
        const inputData = action.payload;

        const response = yield api.postMethod("live_stream_earnings", inputData);
        if (response.data.success) {
            yield put({
                type: FETCH_LIVESTREAM_EARNINGS_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({ type: FETCH_LIVESTREAM_EARNINGS_FAILURE });
        }
    } catch (error) {
        yield put({ type: FETCH_LIVESTREAM_EARNINGS_FAILURE });
    }
}

export default function* CreatorEarningsSaga() {
    yield takeLatest(FETCH_VIDEO_EARNINGS_REQUEST, fetchVideoSaga);
    yield takeLatest(FETCH_TIP_EARNINGS_REQUEST, fetchTipSaga);
    yield takeLatest(FETCH_SUBS_EARNINGS_REQUEST, fetchSubsSaga);
    yield takeLatest(FETCH_PAID_EARNINGS_REQUEST, fetchPaidPostSaga);
    yield takeLatest(FETCH_LIVESTREAM_EARNINGS_REQUEST, fetchLiveStreamSaga);
}